import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { db } from "../firebase-config";
import ResponsiveAppBar from "./Navbar/ResponsiveAppBar";
import { CircularProgress, Box } from "@mui/material";

const pages_manager = [
  { title: "Dashboard", route: "/dashboard" },
  { title: "Events", route: "/events" },
  { title: "Venues", route: "/venues" },
  { title: "Bands", route: "/bands" },
  { title: "Scraper", route: "/scraper" },
  { title: "Pages", route: "/pages" },
];

const ProtectedRoute = (props) => {
  const { children, role } = props;
  const { user } = useUserAuth();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        try {
          const userDoc = await db.collection("users").doc(user.uid).get();
          if (userDoc.exists) {
            const userData = userDoc.data();
            setUserRole(userData);
          } else {
            // User document doesn't exist in Firestore
            setUserRole(null);
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
          setUserRole(null);
        }
      }
      setLoading(false);
    };

    fetchUserRole();
  }, [user]);

  // Show loading spinner while checking permissions
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Check if user is authenticated and has required permissions
  if (!user || !userRole?.isApproved || !userRole?.isManager) {
    localStorage.clear();
    return <Navigate to="/" />;
  }

  return (
    <>
      <ResponsiveAppBar pages={pages_manager} />
      <div style={{ marginTop: "69px" }}>{children}</div>
    </>
  );
};

export default ProtectedRoute;
